function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.00016 0.0834961C3.11735 0.0834961 0.000163078 3.22803 0.000163078 7.0835C0.000163078 10.9663 3.11735 14.0835 7.00016 14.0835C10.8556 14.0835 14.0002 10.9663 14.0002 7.0835C14.0002 3.22803 10.8556 0.0834961 7.00016 0.0834961ZM6.34391 4.23975C6.34391 3.88428 6.61735 3.5835 7.00016 3.5835C7.35563 3.5835 7.65641 3.88428 7.65641 4.23975V7.73975C7.65641 8.12256 7.35563 8.396 7.00016 8.396C6.61735 8.396 6.34391 8.12256 6.34391 7.73975V4.23975ZM7.00016 11.021C6.50798 11.021 6.12516 10.6382 6.12516 10.1733C6.12516 9.7085 6.50798 9.32568 7.00016 9.32568C7.46501 9.32568 7.84782 9.7085 7.84782 10.1733C7.84782 10.6382 7.46501 11.021 7.00016 11.021Z",
  fill: "#BA1701"
});

function SvgExclamation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.25a1515d.svg";
export { ForwardRef as ReactComponent };